import { AuthenticationError } from './AuthenticationError';

export class UnauthorizedError extends AuthenticationError {
	constructor(message: string, cause?: Error) {
		super('ERROR_UNAUTHORIZED', message, cause);
	}
}
